import { combineReducers } from 'redux';
import {
    ILeadState,
    leadReducer,
} from '@/Lead/reducer';

export interface IGlobalState {
  lead: ILeadState;
}

export default combineReducers({
    lead: leadReducer,
});
